import ms, { type StringValue } from "ms";
import { z } from "zod";

const isMsParseable = (val: string): boolean => {
  try {
    return ms(val as StringValue) != null;
  } catch {
    return false;
  }
};

/**
 * A trigger's `workflowExecutionTimeout`: how long a run it starts may take.
 * The backend reads it off the trigger that fired (resolveWorkflowExecutionTimeout).
 */
export const workflowExecutionTimeoutSchema = z
  .string()
  .optional()
  .refine((val) => val === undefined || isMsParseable(val), {
    message:
      "Must be a ms-parseable duration string (e.g., '2 hours', '30 minutes', '90s')",
  })
  .describe(
    "Max workflow execution time as ms-parseable string (e.g., '2 hours'). Defaults to 1 hour.",
  );
